
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail/home/success",
      function () {
        return require("private-next-pages/retail/home/success.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retail/home/success"])
      });
    }
  